import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ContentBlock from '../_components/ContentBlock'

const useStyles = makeStyles<Theme, ScheduleConsultationProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'ColorVisualizer' }
)

export interface ScheduleConsultationProps {
  classes?: StyleClasses<typeof useStyles>
}

function ColorVisualizer(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentBlock
        img={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/color-visualizer.png'}
        title={<>Paint Color Visualizer</>}
        description={<>Upload a photo, then virtually paint your scene and compare colors side-by-side.</>}
        linkHref="https://www.sherwin-williams.com/en-us/color/color-tools/color-visualizer"
        linkLabel="TRY VISUALIZER"
        styles={{ padding: '40px' }}
      />
    </div>
  )
}

export default ColorVisualizer
